export default function(http) {
  return {
    queryUserList(data) {
      return http.json({
        url: "/api/sso/queryUserList",
        data,
      });
    },
    doSsoLogin(data) {
      return http({
        url: `/sso/token`,
        method: "post",
        data: data,
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/sso.js